export const MAX_COMMENT_LENGTH = 3000
